module.exports = __webpack_public_path__ + "img/dots_pattern_2.8fb27d82.svg";